/**
 * 読み込みたい Google Fonts の一覧
 */
const googleFontFamilies = [
    'Noto+Sans+JP:300,400,500,700,900',    // Noto Sans
    'Poppins:300,400,500,700,900',         // Poppins
    // 'Noto+Serif+JP:300,400,500,700,900',   // Noto Serif
    // 'M+PLUS+Rounded+1c:400,700',           // M PLUS Rounded 1c
    // 'Sawarabi+Mincho',                     // さわらび明朝
    // 'Hannari',                             // はんなり明朝
];

(function () {
    if (!Array.isArray(googleFontFamilies) || googleFontFamilies.length === 0) return;

    window.WebFontConfig = {
        google: {
            families: googleFontFamilies
        },
        active: function () {
            try {
                sessionStorage.setItem('fontsLoaded', 'true');
            } catch (e) {
                console.warn('sessionStorage への保存に失敗しました:', e);
            }
        },
        inactive: function () {
            console.warn('WebFont の読み込みに失敗しました。');
        }
    };

    function loadWebFontScript() {
        const script = document.createElement('script');
        script.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
        script.type = 'text/javascript';
        script.async = true;
        script.crossOrigin = 'anonymous';

        script.onerror = function () {
            console.error('WebFont Loader の読み込みに失敗しました。');
        };

        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        } else {
            document.head.appendChild(script);
        }
    }

    function scheduleWebFontLoading() {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(function () {
                loadWebFontScript();
            });
        } else {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', function () {
                    loadWebFontScript();
                });
            } else {
                loadWebFontScript();
            }
        }
    }

    scheduleWebFontLoading();
})();
